/**
 * Auth Layout for Tenant Portal
 * ==============================
 * تخطيط صفحات المصادقة
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import './AuthLayout.css';

const AuthLayout = () => {
  return (
    <div className="tenant-auth-layout">
      <div className="tenant-auth-layout__bg">
        <div className="tenant-auth-layout__pattern" />
      </div>
      <div className="tenant-auth-layout__content">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
